import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { NavigateBefore, NavigateNext } from "@mui/icons-material";

interface MobilePaginationControlsProps {
    page: number;
    totalPages: number;
    canGoNext: boolean;
    canGoPrev: boolean;
    onNext: () => void;
    onPrev: () => void;
    startIndex: number;
    endIndex: number;
    total: number;
}

/**
 * Reusable prev/next pagination bar for mobile card list views.
 * Renders nothing when there is only one page.
 */
export const MobilePaginationControls: React.FC<
    MobilePaginationControlsProps
> = ({
    page,
    totalPages,
    canGoNext,
    canGoPrev,
    onNext,
    onPrev,
    startIndex,
    endIndex,
    total,
}) => {
    if (totalPages <= 1) return null;

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 1.5,
                py: 1,
            }}
        >
            <Button
                size="small"
                variant="outlined"
                startIcon={<NavigateBefore />}
                onClick={onPrev}
                disabled={!canGoPrev}
            >
                Prev
            </Button>

            <Typography variant="caption" color="text.secondary">
                {startIndex + 1}–{endIndex} of {total} &nbsp;·&nbsp; Page{" "}
                {page + 1}/{totalPages}
            </Typography>

            <Button
                size="small"
                variant="outlined"
                endIcon={<NavigateNext />}
                onClick={onNext}
                disabled={!canGoNext}
            >
                Next
            </Button>
        </Box>
    );
};
